import { fakeSigns } from '@/mocks/home';

export default function SafetySection() {
  return (
    <section id="safety" className="scroll-mt-24 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.3fr]">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-accent-700">Safety Guide</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">仿冒站点防伪指南</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              换地址、找入口的过程中，最容易遇到仿冒站点。它们往往在域名、弹窗和付费引导上做手脚，
              下面四类特征是最常见的套路，遇到任意一条都应立即关闭页面。
            </p>
            <div className="mt-6 overflow-hidden rounded-lg border border-background-200">
              <div className="aspect-[16/10] w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20protective%20shield%20concept%20made%20of%20warm%20bronze%20and%20amber%20geometric%20shapes%2C%20minimal%20editorial%20style%2C%20soft%20studio%20lighting%2C%20dark%20background%2C%20no%20text&width=1200&height=800&seq=baoliao-safe-01&orientation=landscape"
                  alt="防伪与安全核验示意"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {fakeSigns.map((sign) => (
              <div key={sign.title} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${sign.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{sign.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{sign.desc}</p>
              </div>
            ))}
            <div className="rounded-lg bg-foreground-950 p-5 text-background-100 sm:col-span-2">
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-background-50">
                <i className="ri-phone-line text-primary-300" aria-hidden="true" />
                遇到可疑页面的处理方式
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                不要填写任何账号、验证码或支付信息，不要点击页面上的下载与充值按钮。关闭页面后，
                改用自己收藏的官方地址重新访问，并对照"地址核对清单"确认。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}